import { Currency } from '@/constants';
import Big from '@/utils/Bigjs';
import { addThousandsSeparator, convertBigIntToString } from '@/utils/number';

export const formatDecimalsAmount = (currency: Currency, amount: string | number | bigint): string => {
  switch (currency) {
    case Currency.BTC:
      if (
        Big(amount.toString())
          .abs()
          .lt(10 ** 6)
      ) {
        return `${addThousandsSeparator(amount.toString())} sat`;
      }
      return `${convertBigIntToString(BigInt(amount), Currency.BTC, undefined, true)} BTC`;

    case Currency.LTC:
      if (
        Big(amount.toString())
          .abs()
          .lt(10 ** 6)
      ) {
        return `${addThousandsSeparator(amount.toString())} lit`;
      }
      return `${convertBigIntToString(BigInt(amount), Currency.LTC, undefined, true)} LTC`;

    default:
      return amount.toString();
  }
};

export const formatAmountToFiat = (currency: Currency, amount: bigint | number, fiatPrice: number) => {
  return `$ ${Big(convertBigIntToString(BigInt(amount), currency, undefined, true))
    .mul(fiatPrice)
    .toFixed(2)}`;
};
